// extracted by mini-css-extract-plugin
export default {"modalBody":"archiveJobModal_modalBody__FiSd-"};